var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('img',{staticClass:"banner-style w-100",attrs:{"src":"/images/public/hotel_list_banner.gif"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }